var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"agent-password"},[_c('v-card-title',{staticClass:"card-title"},[_vm._v("\n    Email\n  ")]),(_vm.profile)?_c('v-card-text',{staticClass:"email-info"},[_c('span',[_vm._v(_vm._s(_vm.profile.email))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }